import { axiosClient } from '@/features'
import { ApiRoutes } from '@/routes'

export const kycService = {
  getKycToken: async (): Promise<{ token: string }> => {
    const req = await axiosClient.get(ApiRoutes.KYC_TOKEN)
    return req.data
  },

  linkEmail: async (email: string, token?: string | null) => {
    const tokenHeaders = token && {
      'Go-Defi-CF-Token': token,
    }

    const request = await axiosClient.post(ApiRoutes.LINK_EMAIL, {
      email,
    }, {
      headers: tokenHeaders,
    })
    return request.data
  },

  linkEmailVerify: async (email: string, otp: string) => {
    const request = await axiosClient.post(ApiRoutes.LINK_EMAIL_VERIFY, {
      email,
      otp,
    })
    return request.data
  },

  linkPhone: async (phone: string, channel: 'WHATSAPP' | 'SMS') => {
    const request = await axiosClient.post(ApiRoutes.LINK_PHONE, {
      phoneNumber: phone,
      channel,
    })
    return request.data
  },

  linkPhoneVerify: async (phone: string, otp: string) => {
    const request = await axiosClient.post(ApiRoutes.LINK_PHONE_VERIFY, {
      phoneNumber: phone,
      otp,
    })
    return request.data
  },
}
